import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Route from "./Route";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ServiceProvider from "./hooks/context/ServiceContext";

function App() {

  return (
    <>
      <ServiceProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Route />
          <ToastContainer />
        </LocalizationProvider>
      </ServiceProvider>
    </>
  );
}

export default App;
